"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpPopRightAuth = void 0;
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const ClassesTags_1 = require("../ClassesTags");
const Helper_1 = require("../Helper");
class CmpPopRightAuth extends tmpls_1.CmpPopRightAuthBase {
    constructor() {
        super();
        const ctrl = this.ctrls;
        ctrl.backgroud.onclick =
            ctrl.btnClose.onclick = () => { this.hide(); if (this._callback)
                this._callback(false); };
        ctrl.btnSendCode.onclick = () => this._trySendSMSCodeAsync();
        ctrl.btnResendCode.onclick = () => this._trySendSMSCodeAsync();
        ctrl.btnSubmitCode.onclick = () => this._trySubmitCodeAsync();
        ctrl.btnChangePhone.onclick = () => this.reset();
        ctrl.iPhone.el.oninput = () => {
            let numbers = this._getPhone();
            numbers = numbers.slice(1);
            let formatted = '+7';
            if (numbers.length > 0)
                formatted += '(' + numbers.slice(0, 3);
            if (numbers.length > 3)
                formatted += ')' + numbers.slice(3, 6);
            if (numbers.length > 6)
                formatted += '-' + numbers.slice(6, 8);
            if (numbers.length > 8)
                formatted += '-' + numbers.slice(8, 10);
            ctrl.iPhone.value = formatted;
            this._setErrorPhone();
        };
        ctrl.iPhone.el.onblur = () => { if (ctrl.iPhone.value == "+7")
            ctrl.iPhone.value = ''; };
        Helper_1.Helper.addEnterPressEvent(ctrl.iPhone.el, () => this._trySendSMSCodeAsync());
        this._codes = [ctrl.iCode0, ctrl.iCode1, ctrl.iCode2, ctrl.iCode3];
        const funcOnInput = (i) => {
            const prev = this._codes[i - 1];
            const cur = this._codes[i];
            const next = this._codes[i + 1];
            this._setErrorCode();
            if (cur.value.length == 0 && prev)
                prev.el.focus();
            if (cur.value.length > 1) {
                if (next) {
                    next.value = cur.value.slice(1);
                    next.el.focus();
                }
                cur.value = cur.value.slice(0, 1);
                if (next == ctrl.iCode3)
                    this._trySubmitCodeAsync();
            }
        };
        for (let i = 0; i < 4; i++)
            this._codes[i].el.oninput = () => funcOnInput(i);
        Helper_1.Helper.addEnterPressEvent(ctrl.iCode3.el, () => this._trySubmitCodeAsync());
    }
    reset(callback = undefined) {
        this._callback = callback;
        const ctrl = this.ctrls;
        ctrl.blockCode.hide();
        ctrl.iPhone.value = '';
        ctrl.iPhone.enable();
        ctrl.iCode0.value = '';
        ctrl.iCode1.value = '';
        ctrl.iCode2.value = '';
        ctrl.iCode3.value = '';
        ctrl.btnSendCode.show();
        ctrl.btnChangePhone.hide();
        ctrl.btnResendCode.hide();
        ctrl.btnSubmitCode.hide();
        ctrl.lResendCodeTimer.hide();
    }
    _trySendSMSCodeAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrl = this.ctrls;
            const phone = this._getValidPhone();
            if (!phone) {
                this._setErrorPhone("Неверный номер телефона");
                return;
            }
            ctrl.btnSendCode.disable();
            const result = yield App_1.App.Inst.auth.tryAuthByPhoneAsync(phone);
            ctrl.btnSendCode.enable();
            if (!result)
                return;
            ctrl.blockCode.show();
            ctrl.iPhone.disable();
            ctrl.btnSendCode.hide();
            ctrl.btnChangePhone.show();
            ctrl.btnResendCode.show();
            ctrl.btnSubmitCode.show();
            ctrl.iCode0.el.focus();
            this._startTimer();
        });
    }
    _startTimer() {
        this.ctrls.btnResendCode.hide();
        this.ctrls.btnChangePhone.hide();
        this.ctrls.lResendCodeTimer.show();
        this._timerPos = 10;
        if (this._timerId)
            clearTimeout(this._timerId);
        this._timer();
    }
    _timer() {
        this.ctrls.lResendCodeTime.text = this._timerPos + "";
        this._timerPos--;
        if (this._timerPos > 0)
            this._timerId = setTimeout(() => this._timer(), 1000);
        else {
            this._timerId = undefined;
            this.ctrls.lResendCodeTimer.hide();
            this.ctrls.btnResendCode.show();
            this.ctrls.btnChangePhone.show();
        }
    }
    _trySubmitCodeAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrl = this.ctrls;
            const code = this._getValidCode();
            if (!code) {
                this._setErrorCode("Неверный код");
                return;
            }
            ctrl.btnSubmitCode.disable();
            const result = yield App_1.App.Inst.auth.tryConfirmSMSAsync(code, { callback: (e, args) => {
                    if (e && e.code)
                        if (e.code == 401) {
                            this._setErrorCode("Превышено кол-во ошибок");
                            return;
                        }
                        else
                            this._setErrorCode("Неверный код");
                }
            });
            ctrl.btnSubmitCode.enable();
            if (!result)
                return;
            this.hide();
            if (this._callback)
                this._callback(true);
        });
    }
    _setErrorCode(error = "") {
        if (!error) {
            this.ctrls.blockCode.removeClass(ClassesTags_1.ClassesTags.Invalid);
            return;
        }
        this.ctrls.lErrorSMS.text = error;
        this.ctrls.blockCode.addClass(ClassesTags_1.ClassesTags.Invalid);
        this._clearCodeAndFocus();
    }
    _setErrorPhone(error = "") {
        if (!error) {
            this.ctrls.blockPhone.removeClass(ClassesTags_1.ClassesTags.Invalid);
            return;
        }
        this.ctrls.lErrorPhone.text = error;
        this.ctrls.blockPhone.addClass(ClassesTags_1.ClassesTags.Invalid);
    }
    _clearCodeAndFocus() {
        const ctrl = this.ctrls;
        ctrl.iCode0.value = ctrl.iCode1.value = ctrl.iCode2.value = ctrl.iCode3.value = '';
        ctrl.iCode0.el.focus();
    }
    _getPhone() {
        const raw = this.ctrls.iPhone.value.replace(/\D/g, '');
        let numbers = raw;
        if (numbers.startsWith('8'))
            numbers = '7' + numbers.slice(1);
        if (!numbers.startsWith('7'))
            numbers = '7' + numbers;
        if (numbers.length > 11)
            numbers = numbers.slice(0, 11);
        return numbers;
    }
    _getValidPhone() {
        let numbers = this._getPhone();
        if (numbers.length == 11)
            return numbers;
        return;
    }
    _getValidCode() {
        let code = "";
        for (const i of this._codes)
            code += i.value;
        if (code.length != 4)
            return;
        return code;
    }
}
exports.CmpPopRightAuth = CmpPopRightAuth;
//# sourceMappingURL=CmpPopRightAuth.js.map